import { FONT_CATEGORIES, FONT_ONLY_CATEGORIES } from '../designPageTypes';
import { groupFontChoices, resolveFontFamily } from '../designPageUtils';
import useDesignFontSettings from './designFontSettings/useDesignFontSettings';
import DesignColorInput from './DesignColorInput';
import DesignStatusMessage from './DesignStatusMessage';

export type DesignFontsTabProps = {
  hasRestaurant: boolean;
  isActive: boolean;
};

const DesignFontsTab = ({ hasRestaurant, isActive }: DesignFontsTabProps) => {
  const { settingsLoading, fontSettingsError, fontChoices, fonts, setFamily, setFontColor } =
    useDesignFontSettings(isActive);

  if (!hasRestaurant) {
    return <DesignStatusMessage message="Select a restaurant to edit design settings." />;
  }

  if (settingsLoading) {
    return <DesignStatusMessage message="Loading fonts…" />;
  }

  if (fontChoices.length === 0) {
    return <DesignStatusMessage message="No fonts are available." />;
  }

  const fontGroups = groupFontChoices(fontChoices);

  return (
    <div className="design-page__fonts">
      {fontSettingsError && <DesignStatusMessage message={fontSettingsError} variant="error" />}
      {FONT_CATEGORIES.map(({ id, label }) => (
        <section key={id} className="design-page__font-section">
          <h2 className="design-page__font-section-title">{label}</h2>
          <div className="design-page__font-row">
            <div className="design-page__field">
              <label className="design-page__font-field-label" htmlFor={`design-font-${id}`}>
                <span className="design-page__color-label">select font</span>
                <select
                  id={`design-font-${id}`}
                  className="design-page__font-select"
                  value={resolveFontFamily(fonts[id].family, fontChoices)}
                  onChange={(e) => setFamily(id, e.target.value)}
                >
                  {fontGroups.map((group) => (
                    <optgroup key={group.label} label={group.label}>
                      {group.fonts.map((font) => (
                        <option key={font.title} value={font.title}>
                          {font.title}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select>
              </label>
            </div>
            {!FONT_ONLY_CATEGORIES.includes(id) && (
              <div className="design-page__field design-page__field--color">
                <span className="design-page__color-label">select font color</span>
                <DesignColorInput value={fonts[id].color} label={label} onChange={(color) => setFontColor(id, color)} />
              </div>
            )}
          </div>
        </section>
      ))}
    </div>
  );
};

export default DesignFontsTab;
